import React, { useEffect, useRef, useState } from 'react';
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Card,
  Select,
  Typography,
  Box,
  FormHelperText,
  Stack,
  InputAdornment,
  Tooltip,
  IconButton,
  FormControlLabel,
  RadioGroup,
  Radio,
  Switch,
  Badge,
  Zoom,
  CircularProgress,
} from '@mui/material';
import InputMask from 'react-input-mask';
import MDButton from 'components/MDButton';
import { addStore, deleteStore, updateStore } from '../../redux/slices/storeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { openSnackbar, uploadImage } from '../../redux/slices/common';
import MapWithPolygon from 'components/googleMaps';
import { useNavigate, useParams } from 'react-router-dom';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import GoogleSuggestion from 'components/googleMaps/GoogleSuggestion';
import { UploadFile } from '@mui/icons-material';
import { isEmptyObject } from 'utilities/common';
import { isValidFileExtension } from 'utilities/common';
import dayjs from 'dayjs';
import DateRange from 'components/dateRangePicker/DateRange';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import PlusIcon from 'common/customIcons/plus';
import MDInput from 'components/MDInput';
import { storeValidation } from 'validations/store';

const uploadThumbnailImage = {
  borderRadius: '20px',
  width: '160px',
  height: '160px',
  objectFit: 'cover',
  boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};
const circularProgressIcon = {
  backgroundColor: '#fff',
  borderRadius: 10,
  p: .5,
  position: 'absolute'
};
const badgeCircularProgressIcon = {
  backgroundColor: '#fff',
  borderRadius: 10,
  p: .5,
  mr: 14,
  mt: 14
};

const AddStiloStoreForm = () => {
  const { storeDetails, loading = false } = useSelector(state => state.stores);
  const { isUploading = false } = useSelector(state => state.common);
  const [uploadedKML, setUploadedKML] = useState('');
  const kmlRef = useRef();
  const addressError = useRef(false);
  const { storeId } = useParams();
  const [disabled] = useState(true);
  const uploadedFileField = useRef(null);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    storeName: '',
    email: '',
    phone: '',
    subscription: '',
    range: '',
    valiDateFrom: null,
    valiDateTo: null,
    isLifeTime: false,
    address: '',
    isViewUser: true,
    status: 'active',
    send: false,
    kml: '',
    storeImage: '',
    platform:""
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isToggleOn, setIsToggleOn] = useState(false);

  const uploadKMLHandler = async (e) => {
    if (e.target.files.length) {
      if (!isValidFileExtension(e.target.files[0], '.kml')) {
        showMessage('Upload only KML file', 'error');
        return;
      }
      const file = e.target.files[0];
      const body = new FormData();
      body.append('filePath', file);
      dispatch(uploadImage(body)).unwrap().then((res => {
        let errorsObj = { ...errors };
        delete errorsObj.uploadedKML;
        setErrors(errorsObj);
        setUploadedKML(res?.fileUrl);
      })).catch(() => { });
      e.target = '';

    }
  };

  const setDateRange = (dates) => {
    if (dates && dates.length === 2) {
      setFormData({
        ...formData,
        valiDateFrom: dates[0],
        valiDateTo: dates[1],
        isLifeTime: false
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (['city', 'state', 'zipcode'].includes(name)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        address: {
          ...prevFormData.address,
          [name]: value
        }
      }));
    }
    else {
      const newValue = name === 'isViewUser' ? value === 'true' : value;
      setFormData({ ...formData, [name]: newValue });
    }
  };

  const handleSwitch = () => {
    setIsToggleOn(!isToggleOn);
    setFormData({ ...formData, isLifeTime: !formData.isLifeTime, valiDateFrom: null, valiDateTo: null });
  };

  const deleteHandler = (storeId) => {
    dispatch(setModalLoader(true));
    dispatch(deleteStore(storeId)).unwrap().then((res) => {
      showMessage(res?.message, 'success');
      dispatch(closeCustomModalDialog());
      navigate('/stores');
    }).catch((err) => {
      dispatch(setModalLoader(false));
      showMessage(err?.message, 'error');
    });
  };

  const googleAddressErrorHandler = (status = false) => {

    addressError.current = status;
    if (status) {
      setErrors({ ...errors, address: 'Address is required' });
    }
    else {
      setErrors(prevErrors => ({ ...prevErrors, address: '' }));
    }
  };

  const handleSubmit = (e, send = false) => {
    e.preventDefault();

    // const { errors, isValid } = storeValidation({ ...formData, uploadedKML });
    // if (!isValid) {

    //   setErrors(errors);
    //   return;
    // }


    setErrors({});
    const payload = {
      storeName: formData.storeName,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData?.phone?.replace(/[^\d]/g, ''),
      subscription: formData.subscription,
      valiDateFrom: dayjs(formData.valiDateFrom).valueOf(),
      valiDateTo: dayjs(formData.valiDateTo).valueOf(),
      isLifeTime: formData.isLifeTime,
      address: formData?.address,
      isViewUser: formData.isViewUser,
      status: formData.status,
      kml: uploadedKML || formData?.kml,
      branchId: storeDetails.branchId,
      platform:formData?.platform ||'hyperwolf'
    };
    
    if (send) {
      payload.send = send;
    }
    if (formData?.storeImage) {
      payload.storeImage = formData?.storeImage;
    }
    if (storeId) {
      dispatch(updateStore({ data: payload, storeId })).unwrap().then((res) => {
        showMessage(res?.message, 'success');
        navigate(-1);
      }).catch((err) => {
        showMessage(err?.message, 'error');
      });
    } else {
      dispatch(addStore(payload)).unwrap().then((res) => {
        showMessage(res?.message, 'success');
        navigate('/stores');
      }).catch((err) => {
        showMessage(err?.message, 'error');
      });
    }
  };

  const showMessage = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  useEffect(() => {
    if (!isEmptyObject(storeDetails)) {
      let payload = {
        ...storeDetails, validUpto: storeDetails?.validUpto ? dayjs(storeDetails?.validUpto) : ''
      };
      if (storeDetails?.kml) {
        setUploadedKML(storeDetails?.kml);
      }
      setFormData({ ...payload });
    }
  }, [storeDetails]);

  const memberstoreImageUploader = async (e) => {
    uploadedFileField.current = 'storeImages';
    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append('filePath', file);
      // res.fileUrl
      dispatch(uploadImage(body)).unwrap().then((res => {
        setFormData({ ...formData, storeImage: res.fileUrl });
      }));
    }
  };

  return (
    <Box p={{ xs: 2, sm: 3, lg: 4 }}>
      <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
        <Grid>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2} mb={4.5}>
            <Typography variant='h4' fontWeight="semibold" color="secondary">{storeId ? 'Update' : 'Add'} Store</Typography>
            <Box display="flex" alignItems="center" gap={1.25}>
              {storeId &&
                <>
                  <Typography variant='h5' fontWeight="semibold" color="secondary">Status</Typography>
                  <Stack direction="row" alignItems="center" gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor="#F2F3F7">
                    <MDButton
                      sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                      type='button'
                      variant={formData?.status === 'active' ? 'contained' : 'text'}
                      color={formData?.status === 'active' ? 'success' : 'dark'}
                      size="small"
                      onClick={() => storeId ? (formData?.kml || uploadedKML) && setFormData({ ...formData, status: 'active' }) : uploadedKML && setFormData({ ...formData, status: 'active' })}
                    >
                      Active
                    </MDButton>
                    <MDButton
                      sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                      type='button'
                      variant={formData?.status !== 'active' ? 'contained' : 'text'}
                      color={formData?.status !== 'active' ? 'error' : 'dark'}
                      size="small"
                      onClick={() => setFormData({ ...formData, status: 'inactive' })}
                    >
                      Inactive
                    </MDButton>
                  </Stack>
                </>
              }
            </Box>
          </Stack>
          <Grid container spacing={2.5} mb={4.5}>
            <Grid item xs={12} md={6} lg={6}>
              <TextField className="form-input" error={errors?.storeName} helperText={errors.storeName} fullWidth label="Store Name*" name="storeName" value={formData?.storeName} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <FormControl fullWidth>
                <InputLabel>Platform</InputLabel>
                <Select
                  className="form-select"
                  error={Boolean(errors?.strainType)}
                  onChange={handleChange} label="Platform" name="platform" value={formData.platform}>
                  <MenuItem value='hemp'>Hemp</MenuItem>
                  <MenuItem value='stilo'>Stilo</MenuItem>
                  <MenuItem value='hyperwolf'>Hyperwolf</MenuItem>
                </Select>
                {Boolean(errors?.strainType) && <FormHelperText error>{errors?.strainType}</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>

          <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Store Contact Details</Typography>
          <Grid container spacing={2.5} mb={4.5}>
            <Grid item xs={12} md={6} lg={3}>
              <TextField className="form-input" error={errors?.firstName} helperText={errors.firstName} fullWidth label="First Name*" name="firstName" value={formData?.firstName || ''} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextField className="form-input" error={errors?.lastName} helperText={errors.lastName} fullWidth label="Last Name*" name="lastName" value={formData?.lastName} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              {storeId ?
                <TextField className="form-input" error={errors?.email} helperText={errors.email} fullWidth label="Email*" name="email" value={formData?.email} onChange={handleChange} disabled />
                :
                <TextField className="form-input" error={errors?.email} helperText={errors.email} fullWidth label="Email*" name="email" value={formData?.email} onChange={handleChange} />
              }
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <InputMask
                className={`form-input mobile-number-field ${storeId ? 'disabled' : ''}`}
                fullWidth
                error={errors?.phone}
                helperText={errors.phone}
                label="Mobile Number*"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                mask='(999) 999-9999'
                maskChar=''
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    disableUnderline
                    InputProps={{
                      ...inputProps.InputProps,
                      startAdornment: <InputAdornment position="start" className='black-txt'><Typography variant='h6' fontWeight="medium" lineHeight="1.25">+1</Typography></InputAdornment>,
                      readOnly: storeId ? disabled : '',
                      style: { opacity: storeId && disabled ? 1 : 1 }
                    }}
                  />
                )}
              </InputMask>
            </Grid>
          </Grid>

          <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Address</Typography>
          <Grid container spacing={2.5} mb={4.5}>
            <Grid item xs={12} className="address-field">
              {
                window?.google && <GoogleSuggestion addressValue={formData?.address.address} googleAddressErrorHandler={googleAddressErrorHandler} storepage={false}
                  onClearAddress={(address) => setFormData({ ...formData, address })}
                  addressChangeHandler={(address) => setFormData({ ...formData, address })} />
              }
              {errors?.address && <FormHelperText error>{errors?.address}</FormHelperText>}
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextField className="form-input" fullWidth label="City*" name="city" value={formData?.address.city || ''} onChange={handleChange} />
              {errors?.city && <FormHelperText error>{errors?.city}</FormHelperText>}
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextField className="form-input" fullWidth label="State*" name="state" value={formData?.address.state || ''} onChange={handleChange} />
              {errors?.state && <FormHelperText error>{errors?.state}</FormHelperText>}
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextField className="form-input"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                inputProps={{ maxLength: 5 }} // Limit to 5 digits
                fullWidth label="Zipcode*" name="zipcode" value={formData?.address.zipcode || ''} onChange={handleChange} />
              {errors?.zipcode && <FormHelperText error>{errors?.zipcode}</FormHelperText>}
            </Grid>
          </Grid>
          <Grid container spacing={2.5} mb={4.5}>
            <Grid item xs={12} md={12} lg={12}>
              <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Upload KML File</Typography>
              <Box display='flex' justifyContent='space-between'>
                <Tooltip title={uploadedKML} sx={{
                  whiteSpace: 'pre-wrap',
                }} arrow placement="bottom">
                  <TextField
                    fullWidth
                    label="Upload KML*"
                    disabled={isUploading}
                    className="form-input-upload"
                    value={storeId && storeDetails.kml !== '' ? formData.kml : uploadedKML}
                    error={Boolean(errors.uploadedKML)}
                    helperText={errors.uploadedKML}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton color='secondary' onClick={
                            (e) => {
                              e.stopPropagation();
                              kmlRef.current.click();
                            }
                          }>
                            <UploadFile />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Tooltip>

                <input
                  id="product-image-input"
                  type="file"
                  name="productImageFile"
                  onChange={uploadKMLHandler}
                  ref={kmlRef}
                  accept='.kml'
                  style={{ display: 'none' }}
                />
              </Box>

              {
                uploadedKML && <Grid item xs={12} sm={4} lg={4} md={4}>
                  <Box sx={{
                    borderRadius: 4, overflow: 'hidden', height: 230, m: 2
                    , display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center'
                  }}>
                    <MapWithPolygon kmlUrl={uploadedKML} />
                  </Box>
                </Grid>
              }

              {storeId && !uploadedKML ?
                <Grid item xs={12} lg={4} md={2}>
                  {uploadedKML || formData.kml &&
                    <Box sx={{
                      borderRadius: 4, overflow: 'hidden', height: 230, m: 2
                      , display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center', justifyContent: 'center'
                    }}>
                      <MapWithPolygon kmlUrl={uploadedKML ? uploadedKML : formData?.kml} />
                    </Box>
                  }
                </Grid> : ''
              }
            </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
              <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Permission to view user details</Typography>

              <FormControl className='d-flex custom-checkbox-ui '>
                <RadioGroup
                  value={formData.isViewUser}
                  name='isViewUser'
                  label="Yes or No"
                  onChange={handleChange}
                  color="secondary"
                >
                  <FormControlLabel value={true} control={<Radio color="secondary" />} label="Yes" />
                  <FormControlLabel value={false} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </Grid> */}
          </Grid>
          <Box>
            <Typography variant='body2' fontWeight='medium' mb={1} color="#2E2E3A">Upload Store Image</Typography>
            <Stack direction="row" flexWrap="wrap" gap={1.25} mb={4.5}>
              {formData?.storeImage &&
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                // badgeContent={
                //   <>
                //     {
                //       !isUploading && <PlusIcon color='white' onClick={() => setFormData({ ...formData, storeImage: '' })} fontSize='small' sx={{ backgroundColor: '#FD4438', borderRadius: 10, p: .25, mt: -4, mr: -4, cursor: 'pointer' }} />
                //     }
                //     {
                //       isUploading && uploadedFileField.current === 'storeImages' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                //     }
                //   </>
                // }
                >
                  {formData?.storeImage && <img style={uploadThumbnailImage} src={formData?.storeImage} alt="documentId" />}
                </Badge>}

              <label htmlFor="Id-image">
                <Box bgcolor="#F1F1F1" display="flex" alignItems="center" justifyContent="center" flexDirection="column" minWidth="160px" minHeight="160px" borderRadius="20px" p={2} sx={{ cursor: 'pointer' }}>
                  {
                    !formData?.storeImage && isUploading && uploadedFileField.current === 'storeImages' ? <CircularProgress size={32} color='primary' sx={circularProgressIcon} /> : <Typography variant='body2' fontWeight="medium" textAlign="center">+<br />Upload<br />Image</Typography>
                  }
                </Box>
              </label>

              <MDInput
                id="Id-image"
                type="file"
                name="ID"
                onChange={memberstoreImageUploader}
                fullWidth
                style={{ display: 'none' }}
                accept=".png, .jpg, .jpeg"
              />
              {
                errors?.storeImage && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.storeImage}>{errors?.storeImage}</FormHelperText>
              }
            </Stack>
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mt={4}>
            <MDButton
              sx={{ minWidth: '160px' }}
              type='button'
              variant='contained'
              color='primary'
              onClick={(e) => handleSubmit(e, true)}
              disabled={isUploading || loading}
              loading={loading}

            >
              {storeId ? 'Update' : 'Save & Send'}
            </MDButton>
            {
              storeId && <MDButton
                sx={{ minWidth: '160px', backgroundColor: '#F1F1F1', color: '#FD4438' }}
                type='button'
                variant='contained'
                color='error'
                onClick={() => dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: storeId, deleteType: 'store' }, modal: 'DELETE_MODAL' }))}
              >
                Delete
              </MDButton>
            }
            <MDButton
              sx={{ minWidth: '160px' }}
              type='button'
              variant='outlined'
              color='dark'
              onClick={() => navigate(-1)}

            >
              Cancel
            </MDButton>
          </Stack>
        </Grid>
      </Card>
    </Box >
  );
};

export default AddStiloStoreForm;